const avatar              = require('../../../components/avatar/avatar')
const drawer              = require ('../../../components/drawer/drawer')
const leftnav             = require ('../../../components/leftnav/leftnav')
const leftnavGenrator     = require ('../../../components/leftnav/leftnav-generator')
const page                = require ('../../../components/page/page')
const websocket           = require ('../../../js-network/web-socket')
const backControl         = require ('../../../js/back-control')
const pageMap 			  = require('./staff-page-map')
const settings            = require('../../../js-handler/settings')
const darkTheme		      = require('../../../components/darktheme/darktheme')

import avatarHtml from "./avatar.html";
import drawerHtml from "./drawer.html";
import fabHtml    from "./fab.html";
import appbar     from "./appbar.html";
import leftnavHtml from "./leftnav.html";




export function start(settingsData){  //console.log('STAFF DESKTOP ##########################>', pageMap)
	
	//alert('xxxxx');
	const body = document.body	

	//fab 
	 body.insertAdjacentHTML("beforeend", appbar)  

	 console.log(settingsData)

	 if(settingsData.right === 'user'){
		const settingsBtn = document.getElementById('adminSettings');
		if(!settingsBtn.classList.contains('dn')){ settingsBtn.classList.add('dn')}
	 }

	//Avatar
	body.insertAdjacentHTML("beforeend", avatarHtml)  
	avatar.generator('avatar', settingsData)

	//drawer
	body.insertAdjacentHTML("beforeend", drawerHtml)  
	drawer.start({act:'generator', data:settingsData})
	
		
	//colocar el nombre de la empresa
	body.querySelector('#companyName').innerText = settingsData.company;
	
	
	//leftnav
	
	
	//settingsData.leftnav = settingsRights //remove this 
    leftnavGenrator.insertLeftnav(leftnavHtml)
    leftnavGenrator.controlViewElements(settingsData.leftnav, pageMap)

	//leftnavGenrator.generator( settingsData, leftnavHtml, leftnavArray )

	//pagecontrol
	settingsData.pageMap = pageMap //remove this 
	verificarHash(settingsData)
	backControl.enable()

	//verificar si el tema oscuro esta en el localStorage para setearlo
	if( darkTheme.checkIfExistsDarkTheme() ){
		darkTheme.setDarkTheme()
	}


	//amenidies
	// websocket.init({act:"init"}) 
}

const verificarHash = (settingsData) => {
	const currentHash = window.location.hash.split('-');
	const entidad = currentHash[1]
	const map = Object.keys(pageMap);

	const esRutaValida = map.includes(entidad);

	// console.log(esRutaValida)

	if (esRutaValida) {
		if(settingsData.right == "user"){
			const entitiesPermission = settingsData.leftnav

			entitiesPermission.forEach(i => {
				if(i.entity == entidad){
					if(i.privilegeDB == "readWrite"){
						window.location.hash = `#page-${entidad}-page`;
						return
					}
				}else{
					if(i.privilegeDB == "readWrite"){
						window.location.hash = `#page-${i.entity}-page`;
						return
					}
				}
			});
		}
		return true;
	} else {
		window.location.hash = '';
		if(settingsData.right == "user"){
			const entitiesPermission = settingsData.leftnav

			entitiesPermission.forEach(i => {
				if(i.entity == entidad){
					if(i.privilegeDB == "readWrite"){
						window.location.hash = `#page-${entidad}-page`;
						return
					}
				}else{
					if(i.privilegeDB == "readWrite"){
						window.location.hash = `#page-${i.entity}-page`;
						return
					}
				}
			});
		}
	}
	return
}

// const settingsRights = [
// 	    {entity: "purchase",  privilegeDB: "", privilegeFile: "", privilegeAgrmt: "" },
// 	    {entity: "sale",      privilegeDB: "readOnly", privilegeFile: "readWrite", privilegeAgrmt: "" },
// 	    {entity: "inventory", privilegeDB: "readOnly", privilegeFile: "readWrite", privilegeAgrmt: "" },
// 	    {entity: "customer",  privilegeDB: "readOnly", privilegeFile: "readWrite", privilegeAgrmt: "" },
// 	    {entity: "accounts",  privilegeDB: "readOnly", privilegeFile: "viewOnly",  privilegeAgrmt: "" },
	
// ]
